import styled from 'styled-components';
import { themeVar } from '@/styles/theme';

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  max-width: 420px;
  padding: 0 20px 30px 20px;
  width: 100%;
  border-bottom: 1px solid ${themeVar('border.base')};
`;

export const StatusTitle = styled.h1`
  font-size: 33px;
  font-weight: 400;
  text-align: center;
  line-height: 46.2px;
  color: ${themeVar('font.strong')};
`;

export const StatusDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: ${themeVar('font.base')};
  padding: 10px;
`;
